// extracted by mini-css-extract-plugin
export var cancelButton = "_ow-5";
export var content = "_ow-3";
export var createButton = "_ow-6";
export var drawerContainer = "_ow-0";
export var footer = "_ow-2";
export var header = "_ow-1";
export var orderFormColumn = "_ow-4";